import * as React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

export type SidebarHeaderProps = {
  title: string
  onClose: () => void
  titleSx?: React.CSSProperties
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = (props) => (
  <Box display="flex" alignItems="center" px={1} py={2}>
    <Typography
      style={{
        fontFamily: 'Source Sans Pro SemiBold',
        textTransform: 'uppercase',
        ...props?.titleSx,
      }}
    >
      {props.title}
    </Typography>

    <IconButton
      onClick={props.onClose}
      size="small"
      style={{ marginLeft: 'auto' }}
      data-test-id="bulkActionsSidebarCloseBtn"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
)
SidebarHeader.displayName = 'SidebarHeader'
